import { useI18n } from '@tribeplatform/react-components/i18n'
import { ButtonGroup, IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { useCustomizerNavigation } from '../hooks/index.js'
import { useCustomizerPreview } from '../hooks/use-customizer-preview.hook.js'

export const PreviewScreenSizePicker = () => {
  const { $t } = useI18n()
  const { editNavigation } = useCustomizerNavigation()
  const { previewSize, setPreviewSize } = useCustomizerPreview()

  return (
    <ButtonGroup size="md">
      <IconButton
        disabled={editNavigation}
        pressed={previewSize === 'sm'}
        onClick={() => setPreviewSize('sm')}
        icon={<SvgIcon name="device-mobile" />}
        accessibilityLabel={$t({
          defaultMessage: 'Mobile',
          id: 'Generics.Mobile.Device',
        })}
        tooltip
      />
      <IconButton
        disabled={editNavigation}
        pressed={previewSize === 'md'}
        onClick={() => setPreviewSize('md')}
        icon={<SvgIcon name="device-tablet" />}
        accessibilityLabel={$t({
          defaultMessage: 'Tablet',
          id: 'Generics.Tablet.Device',
        })}
        tooltip
      />
      <IconButton
        disabled={editNavigation}
        pressed={previewSize === 'lg'}
        onClick={() => setPreviewSize('lg')}
        icon={<SvgIcon name="device-desktop" />}
        accessibilityLabel={$t({
          defaultMessage: 'Desktop',
          id: 'Generics.Desktop.Device',
        })}
        tooltip
      />
    </ButtonGroup>
  )
}
